export default __webpack_public_path__ + "static/boulevard2-ae544346647554d070de6767b7a4d20f.jpg";